module.exports = __webpack_public_path__ + "img/Shovel.d74d4149.png";